// removed by extract-text-webpack-plugin
module.exports = {"icon":"UploadFileComponent-icon","browse":"UploadFileComponent-browse"};